import React, {
  useState, useCallback,
} from 'react';
import {
  Alert, AlertTitle, Box, Button, Grid, LinearProgress,
  Typography,
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEraser, faUpload } from '@fortawesome/free-solid-svg-icons';
import { StyledFileInput, StyledFileLabel } from '../../../files/editor';
import { useExchangeFiles } from './hook';
import { EditorControls } from '../../../BaseEditor';
import ExchangeFile from './file';

function LoadGRKSubscription() {
  const [top, setTop] = useState(0);
  const measuredRef = useCallback((node) => {
    if (node !== null) {
      setTop(node.getBoundingClientRect().top);
    }
  }, []);

  const {
    err, onDrop, onDragOver, onFileInputChange, data, setData, currentUser, files, onApplyFiles,
    process, percent, onCleanFiles, onDeleteFile,
  } = useExchangeFiles();

  return (
    <Box
      width={1}
    >
      <Typography variant="h5" mb={1} color="secondary">
        Завантаження випіски ГРК (РНР)
      </Typography>
      {err && (
        <Alert severity="error">
          <AlertTitle>Сталася помилка</AlertTitle>
          {err}
        </Alert>
      )}
      <Box
        height={`calc(100vh - ${top}px - 10px)`}
        overflow="auto"
        ref={measuredRef}
        onDragOver={onDragOver}
        onDrop={onDrop}
        sx={{ background: 'white' }}
      >
        {!process && (
        <Alert severity="info">
          <AlertTitle>Додавання файлів</AlertTitle>
          Для того, щоб додати файли - перетяніть іх сюди, або натисніть кнопку:
          <StyledFileLabel>
            <FontAwesomeIcon icon={faUpload} bounce={!files.length} />
            <Typography variant="button" sx={{ ml: 1 }}>
              Завантажити файл
            </Typography>
            <StyledFileInput onChange={onFileInputChange} />
          </StyledFileLabel>
        </Alert>
        )}
        <Box m={2}>
          {process && (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ width: '100%', mr: 1 }}>
              <LinearProgress value={percent} variant="determinate" />
            </Box>
            <Box sx={{ minWidth: 35 }}>
              <Typography variant="body2" color="text.secondary">
                {percent}
                %
              </Typography>
            </Box>
          </Box>
          )}
          <Grid container gap={2}>
            {files.map((file) => (
              <Grid item sm={3} key={file.filename}>
                <ExchangeFile
                  filename={file.filename}
                  success={file.success}
                  type={file.type}
                  loading={file.loading}
                  err={file.error}
                  onDeleteFile={onDeleteFile}
                />
              </Grid>
            ))}
            <Grid item sm={12}>
              <Button
                color="success"
                startIcon={<FontAwesomeIcon icon={faUpload} bounce={!!files.length && !process} />}
                onClick={onApplyFiles}
                disabled={process}
              >
                Відправити файли на обробку
              </Button>
              <Button
                color="warning"
                startIcon={<FontAwesomeIcon icon={faEraser} />}
                onClick={onCleanFiles}
                disabled={process}
              >
                Очистити список файлів
              </Button>
            </Grid>
            <Grid item sm={12}>
              {currentUser.is_superuser && (
              <EditorControls.ItemPicker
                label="Установа"
                value={data.org}
                onChange={(e, v) => setData((o) => ({ ...o, org: v }))}
                backend="/api/catalog/orgs/"
                disabled={process}
              />
              )}
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
}

export default LoadGRKSubscription;
